import SystemLayoutUiService, {SubscribeSystemLayoutUiService} from "app/Service/System/Layout/SystemLayoutUiService"
import SystemModuleService, {subscribeSystemModule} from "app/Service/System/Module/SystemModuleService"
import WebPathService, {OPERATION_SETTINGS, SubWebPathService} from "app/Service/System/WebPathService"
import ToolbarLayoutController from "app/WebController/Toolbar/ToolbarLayoutController"
import ToolbarModuleController from "app/WebController/Toolbar/ToolbarModuleController"
import ToolbarModuleSettingsController from "app/WebController/Toolbar/ToolbarModuleSettingsController"
import Logger from "logger/logger"
import React, {useEffect, useMemo} from "react"
import {ButtonToolbar} from "react-bootstrap"

function ToolbarController() {
  const {operation} = WebPathService([
    SubWebPathService.operation,
  ], 'ToolbarController')

  const {activeSystemModule} = SystemModuleService([
    subscribeSystemModule.activeSystemModule
  ], 'ToolbarController')

  const {isEditingLayout} = SystemLayoutUiService([
    SubscribeSystemLayoutUiService.editLayout,
  ], 'ToolbarController')

  useEffect(() => {
    Logger('Controller.Toolbar.init')
    return () => {
      Logger('Controller.Toolbar.unloading')
    }
  }, [])

  const toolbar = useMemo(() => {
    if (isEditingLayout)
      return <ToolbarLayoutController/>
    else if (operation === OPERATION_SETTINGS)
      return <ToolbarModuleSettingsController/>
    else if (undefined !== activeSystemModule)
      return <ToolbarModuleController/>
    else
      return null
  }, [operation, isEditingLayout, activeSystemModule])

  return null === toolbar ? null : (
    <ButtonToolbar className={`toolbar__module`} id={`toolbar`}>
      {toolbar}
    </ButtonToolbar>
  )
}

export default ToolbarController
